import { CompactDealCentralCardHeaderActions, DeskingCardHeaderActionsMenu } from '../../deskingActivity/DeskingCard.style';
import { DeskingCardDealLabel } from '../../deskingActivity/DeskingCardDealLabel';
import { Action } from '@interstate/components/Action';
import { DocumentDuplicateIcon, TrashIcon } from '@interstate/components/Icons';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { OpenManualTemplatesListButton, LockDealButton } from '@makemydeal/dr-dash-components';

import { useMultiScenarioActions } from './useMultiScenarioActions';

export const MultiScenarioActions = ({ scopeId }: { scopeId: string }) => {
    const theme = useInterstateTheme();
    const { isPrimaryScope, isDeleteDisabled, isDuplicateDisabled, deleteScope, duplicateScope, makePrimary } =
        useMultiScenarioActions(scopeId);

    return (
        <CompactDealCentralCardHeaderActions theme={theme}>
            <DeskingCardDealLabel
                isPrimaryScope={isPrimaryScope}
                scopeId={scopeId}
                onChangePrimaryDeal={makePrimary}
            ></DeskingCardDealLabel>
            <DeskingCardHeaderActionsMenu>
                <Action
                    actionIcon={{ icon: <TrashIcon />, start: true }}
                    id="delete-deal-draft-button"
                    data-testid="delete-deal-draft-button"
                    onClick={deleteScope}
                    size="lg"
                    disabled={isDeleteDisabled}
                />
                <OpenManualTemplatesListButton />
                <Action
                    actionIcon={{ icon: <DocumentDuplicateIcon />, start: true }}
                    id="duplicate-deal-draft-button"
                    data-testid="duplicate-deal-draft-button"
                    onClick={duplicateScope}
                    size="lg"
                    disabled={isDuplicateDisabled}
                />
                <LockDealButton />
            </DeskingCardHeaderActionsMenu>
        </CompactDealCentralCardHeaderActions>
    );
};
